<template>
  <div class="p-20">
    <van-form ref="form" :show-error="false" error-message-align="right">
      <van-cell-group>
        <van-field v-f-show="'ssbm'" input-align="right" name="ssbm" :required="isRequired('ssbm')"
                   :value="formData.ssbm" label="部门" :rules="getRules('ssbm')" placeholder="请选择部门">
          <template #input>
            <view-item @click.native="isShowPopup(ssbm,'ssbm')" :value="formData.ssbm" placeholder="请选择部门"/>
            <van-popup v-model="ssbm.show" position="bottom">
              <van-nav-bar title="选择部门" left-text="取消" right-text="确定" @click-left="ssbm.show = false"
                           @click-right="popupSubmit('ssbm',{label:'label',value:'value'})"/>
              <van-search v-model="ssbm.filterText" @input="pickerSearch($event,ssbm,'label')" clearable shape="round"/>
              <van-picker ref="ssbm" value-key="label" :columns="ssbm.filteredData" @cancel="ssbm.show = false"/>
            </van-popup>
          </template>
        </van-field>
        <van-field v-f-show="'ssxm'" input-align="right" name="ssxm" :required="isRequired('ssxm')"
                   :value="formData.ssxm" :rules="getRules('ssxm')" label="所属项目" placeholder="请选择项目">
          <template #input>
            <view-item @click.native="isShowPopup(ssxm,'ssxm')" :value="formData.ssxm" placeholder="请选择项目"/>
            <van-popup v-model="ssxm.show" position="bottom">
              <van-nav-bar title="选择项目" left-text="取消" right-text="确定" @click-left="ssxm.show = false"
                           @click-right="popupSubmitSsxm('ssxm',{label:'projectName',value:'projectId'})"/>
              <van-search v-model="ssxm.filterText" @input="pickerSearch($event,ssxm,'projectName')" clearable
                          shape="round"/>
              <van-picker :duration="0" ref="ssxm" value-key="projectName" :columns="ssxm.filteredData"
                          @cancel="ssxm.show = false"/>
            </van-popup>
          </template>
        </van-field>
        <van-field v-f-show="'qwjfrq'" v-model="formData.qwjfrq" :required="isRequired('qwjfrq')" name="qwjfrq"
                   label="期望交付日期" placeholder="期望交付日期" input-align="right" :rules="getRules('qwjfrq')">
          <template #input>
            <view-item @click.native="isShowPopup(qwjfrq,'qwjfrq')" :value="formData.qwjfrq"
                       placeholder="请选择期望交付日期"/>
            <van-calendar :min-date="minDate" v-model="qwjfrq.show" ref="qwjfrq" :show-confirm="false"
                          title="选择期望交付日期" @confirm="qwjfrqConfirm"></van-calendar>
          </template>
        </van-field>
        <van-field v-f-show="'cglx'" input-align="right" name="cglx" :required="isRequired('cglx')"
                   :value="formData.cglx" label="采购类型" :rules="getRules('cglx')" placeholder="请选择采购类型">
          <template #input>
            <view-item @click.native="isShowPopup(cglx,'cglx')" :value="formData.cglx" placeholder="请选择采购类型"/>
            <van-popup v-model="cglx.show" position="bottom">
              <van-nav-bar title="选择采购类型" left-text="取消" right-text="确定" @click-left="cglx.show = false"
                           @click-right="popupSubmit('cglx')"/>
              <van-search v-model="cglx.filterText" @input="pickerSearch($event,cglx)" clearable shape="round"/>
              <van-picker ref="cglx" value-key="label" :columns="cglx.filteredData" @cancel="cglx.show = false"/>
            </van-popup>
          </template>
        </van-field>
        <van-field v-f-show="'sqsy'" v-model="formData.sqsy" :readonly="isDisabled('sqsy')"
                   :required="isRequired('sqsy')" name="sqsy" :rules="getRules('sqsy')" type="textarea" maxlength="200"
                   rows="3" autosize label="申请事由" show-word-limit placeholder="请输入申请事由" input-align="right"/>
      </van-cell-group>
      <div class="font-32 font-weight-500 cor-00 m-t-26 m-b-26">采购明细</div>
      <van-cell-group v-for="(item,index) in formData.cgmxb" :key="index" class="b-r-10 m-t-20">
        <div style="border-bottom: 1px solid #EBEBEB" class="p-b-20">
          <van-row type="flex" align="center">
            <van-col :span="22">
              <img class="w-5 h-28" :src="`${image_base_url}/icon_line.png`"></img>
              <span class="cor-33 font-weight-500 font-28 m-l-16">{{ `明细${index + 1}` }}</span>
            </van-col>
            <van-col v-if="isShowIcon('cgmxb')" @click="removeItem(index,'cgmxb')" :span="2">
              <img class="w-30 h-30" :src="`${image_base_url}/shoppingDel.png`"></img>
            </van-col>
          </van-row>
        </div>
        <van-field v-f-show="'cgmxbMc'" :disabled="isDisabled('cgmxbMc')" v-model="item.cgmxbMc" maxlength="50"
                   name="cgmxbMc" :rules="getRules('cgmxbMc')" :required="isRequired('cgmxbMc')" label="名称"
                   placeholder="请输入名称" input-align="right"/>
        <van-field v-f-show="'cgmxbGg'" :disabled="isDisabled('cgmxbGg')" v-model="item.cgmxbGg" maxlength="50"
                   name="cgmxbGg" :rules="getRules('cgmxbGg')" :required="isRequired('cgmxbGg')" label="规格"
                   placeholder="请输入规格" input-align="right"/>
        <van-field v-f-show="'cgmxbSl'" :disabled="isDisabled('cgmxbSl')" v-model="item.cgmxbSl" type="number"
                   name="cgmxbSl" :rules="getRules('cgmxbSl')" :required="isRequired('cgmxbSl')" :maxlength="8"
                   placeholder="请输入采购数量" label="采购数量" input-align="right"></van-field>
        <van-field v-f-show="'cgmxbDw'" :disabled="isDisabled('cgmxbDw')" v-model="item.cgmxbDw" maxlength="50"
                   name="cgmxbDw" :rules="getRules('cgmxbDw')" :required="isRequired('cgmxbDw')" label="单位"
                   placeholder="请输入单位" input-align="right"/>
        <van-field v-f-show="'cgmxbJg'" :disabled="isDisabled('cgmxbJg')" v-model="item.cgmxbJg" type="number"
                   name="cgmxbJg" :rules="getRules('cgmxbJg')" :required="isRequired('cgmxbJg')" :maxlength="8"
                   placeholder="请输入采购金额" label="采购金额" input-align="right"></van-field>
      </van-cell-group>
      <van-row v-if="!isDisabled('cgmxb')">
        <van-col :span="12"></van-col>
        <van-col :span="12">
          <van-button icon="add-o" round native-type="button" color="#FFDA3E" text="添加采购明细" @click="addCgItem"
                      class="width-100"/>
        </van-col>
      </van-row>
      <van-cell-group v-f-show="'zjg'" class="m-t-20">
        <van-field v-f-show="'zjg'" center v-model="formData.zjg" :rules="getRules('zjg')" :required="isRequired('zjg')"
                   label="采购总金额" input-align="right" readonly>
          <template #input>
            <div>
              <span v-text="getFormatValue(formData.zjg)+' 元'" v-if="formData.zjg && formData.zjg != 0"></span>
              <span v-else>无</span>
              <div v-if="formData.zjg && formData.zjg!=0">
                <span class="p-l-20"> 大写：</span>
                <span class="cor-F64646">{{ getChinese(formData.zjg) }}</span>
              </div>
            </div>
          </template>
        </van-field>
      </van-cell-group>

      <van-cell-group class="m-t-20">
        <van-field v-f-show="'zffs'" input-align="right" name="zffs" :required="isRequired('zffs')"
                   :value="formData.zffs" label="支付方式" :rules="getRules('zffs')" placeholder="请选择支付方式">
          <template #input>
            <view-item @click.native="isShowPopup(zffs,'zffs')" :value="formData.zffs" placeholder="请选择支付方式"/>
            <van-popup v-model="zffs.show" position="bottom">
              <van-nav-bar title="选择支付方式" left-text="取消" right-text="确定" @click-left="zffs.show = false"
                           @click-right="popupSubmit('zffs')"/>
              <van-search v-model="zffs.filterText" @input="pickerSearch($event,zffs)" clearable shape="round"/>
              <van-picker ref="zffs" value-key="label" :columns="zffs.filteredData" @cancel="zffs.show = false"/>
            </van-popup>
          </template>
        </van-field>
        <van-field v-f-show="'bz'" v-model="formData.bz" :readonly="isDisabled('bz')" :required="isRequired('bz')"
                   name="bz" :rules="getRules('bz')" type="textarea" maxlength="200" rows="3" autosize label="备注"
                   show-word-limit placeholder="请输入备注" input-align="right"/>
        <van-field v-f-show="'fj'"  class="fileValueBox"  :value.prop="formData.fj" input-align="right" name="fj" :required="isRequired('fj')"
                   :rules="getRules('fj')" label="附件" placeholder="请上传文件">
          <template #input>
            <uploadFiles :disabled="isDisabled('fj')" :files="formData.fj" @success="uploadSuccess"
                         module-type="flow"   @fileRemove="(removedFile)=>handleFileRemove(removedFile,'formData','fj')"></uploadFiles>
          </template>
        </van-field>
      </van-cell-group>
    </van-form>
    <div class="font-32 font-weight-500 cor-00 m-t-26">流程</div>
    <!--      这个是不带选人的流程图    -->
    <flowTrace v-if="!$route.query.reSend && (processInstanceId || $route.query.processInstanceId)" class="m-t-20"
               :flowTraceList="flowTrace" :processInfo="processData"></flowTrace>
    <!--      这个是带选人的流程图    -->
    <approver v-else class="m-t-20" ref="approver" @addUser="addUser" :processData="processData" :formData="formData"/>
    <bottom-bar @submit="submit" @mention="mention"></bottom-bar>
    <van-popup position="bottom" v-model="approver.show">
      <van-nav-bar title="选择办理人" left-text="取消" right-text="确定" @click-left="approver.show = false"
                   @click-right="approverPopupSubmit"/>
      <van-search v-model="approver.filterText" @input="treeSearch($event, $refs.approverTree)" clearable
                  shape="round"/>
      <div style="overflow-y: auto" class="h-vh-50">
        <div class="p-10">
          <el-tree ref="approverTree" @check-change="approverCheckChange($event, $refs.approverTree)" node-key="uuid"
                   check-strictly :data="approver.data" :filter-node-method="filterNode" check-on-click-node
                   show-checkbox/>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {getFormDataByInstanceId} from "@/api/flow";
import cache from "@/plugins/cache";
import {getDictDataByType} from "@/api/dict";
import {getCurrentUserDept, getDeptUserTreeAll, selectMyProjectList} from "@/api/user";
import mixin from "@/mixin/flow";
import moment from "moment/moment";
import uploadFiles from "@/components/uploadFiles/index.vue";
import fileMixins from "@/components/uploadFiles/fileMixins";
import bottomBar from '@/components/flow/bottom-bar.vue'
import flowTrace from '@/components/flow/flowTrace.vue'
import approver from "@/components/flow/approver.vue";


const cgItem = {
  cgmxbMc: "",
  cgmxbGg: "",
  cgmxbSl: "",
  cgmxbDw: "",
  cgmxbJg: ""
}
export default {
  components: {uploadFiles, approver, flowTrace, bottomBar},
  mixins: [mixin,fileMixins],
  watch: {
    'formData.cgmxb': {
      handler(val) {
        // 计算报销总金额 zjg = cgmxb中每一项 cgmxbJg * cgmxbJg 再累加
        this.formData.zjg = val.reduce((total, item) => {
          return total + (item.cgmxbJg ? item.cgmxbJg : 0) * (item.cgmxbSl ? item.cgmxbSl : 0)
        }, 0)
      },
      deep: true
    },
  },
  data() {
    return {
      minDate: new Date(2024, 0, 1),
      formData: {
        flowNo: "",
        sqr: "",
        ssbm: "",
        ssxm: "",
        qwjfrq: "",
        cglx: "",
        sqsy: "",
        cgmxb: [{
          cgmxbMc: "",
          cgmxbGg: "",
          cgmxbSl: "",
          cgmxbDw: "",
          cgmxbJg: ""
        }],
        zjg: '',
        zffs: "",
        bz: "备注",
        fj: []
      },
      rules: {},
      // 所属部门
      ssbm: {
        data: [],
        filteredData: [],
        filterText: '',
        show: false
      },
      // 所属项目
      ssxm: {
        data: [],
        show: false,
        filteredData: [],
        filterText: '',
      },
      // 选人树
      approver: {
        data: [],
        filterText: '',
        show: false
      },
      // 部门用户树
      deptUserTreeAll: {
        data: [],
        filterText: '',
        show: false
      },
      qwjfrq: {
        show: false
      },
      cglx: {
        show: false,
        data: [],
        filteredData: [],
        filterText: '',
      },
      zffs: {
        show: false,
        data: [],
        filteredData: [],
        filterText: '',
      },
    }
  },
  created() {
    const {templateId, groupId, reSend} = this.$route.query
    this.SET_TEMPLATE_ID(templateId)
    this.SET_GROUP_ID(groupId)
    this.init()
    if (reSend && this.$route.query.processInstanceId) { // 重新发起时
      this.$loading.show()
      this.getFormInfo({templateId: this.templateId}).then(res => {
        // 从后台去流程表单数据 只取fomData
        getFormDataByInstanceId(this.$route.query.processInstanceId).then(form => {
          // 合并
          Object.assign(this.formData, res.data.processTemplates.expressVals, form.data)
          this.$loading.hide()
        })
      })
      // 新增时 初始化的时候预定人是当前登录用户
      const currentUserInfo = JSON.parse(cache.session.get("userInfo"))
      this.getCurrentUserDept(currentUserInfo)
    } else if (this.$route.query.processInstanceId && !this.$route.query.reSend) { // 外部跳转时
      this.SET_PROCESS_INSTANCE_ID(this.$route.query.processInstanceId)
      if (this.$route.query.taskId) {
        this.SET_TASK_ID(this.$route.query.taskId)
      }
      this.$loading.show()
      this.getProcessInfo({
        processInstanceId: this.$route.query.processInstanceId,
        taskId: this.$route.query.taskId
      }).then(res => {
        Object.assign(this.formData, res.data.formData)
        this.$loading.hide()
      })
    } else { // 新增时
      // 新增时调用
      this.getFormInfo({templateId: this.templateId, groupId: this.groupId}).then(res => {
        Object.assign(this.formData, res.data.processTemplates.expressVals)
      })
      // 新增时 初始化的时候预定人是当前登录用户
      const currentUserInfo = JSON.parse(cache.session.get("userInfo"))
      this.selectMyProjectList(currentUserInfo)
      this.formData.sqr = currentUserInfo.nickName
      this.getCurrentUserDept(currentUserInfo)
    }
  },
  methods: {
    init() {
      // 获取部门用户树
      this.getDeptUserTreeAll()
      // 支付方式
      getDictDataByType('pay_way').then(res => {
        const data = res.data.map(item => {
          return item.dictLabel
        })
        this.zffs.data = data
        this.zffs.filteredData = data
      })
      // 采购类型
      getDictDataByType('purchase_type').then(res => {
        const data = res.data.map(item => {
          return item.dictLabel
        })
        this.cglx.data = data
        this.cglx.filteredData = data
      })
    },
    uploadSuccess(fileList) { // 每次都会filelist全部丢出来
      this.formData.fj = fileList
    },
    addCgItem() {
      this.formData.cgmxb.push(JSON.parse(JSON.stringify(cgItem)))
    },
    qwjfrqConfirm(date) {
      this.formData.qwjfrq = moment(date).format('YYYY-MM-DD')
      this.qwjfrq.show = false
    },
    // 获取人员所属部门列表
    getCurrentUserDept(user) {
      return new Promise(resolve => {
        getCurrentUserDept({userId: user.id || user.userId}).then(res => {
          this.ssbm.data = res.data
          this.ssbm.filteredData = this.ssbm.data
          resolve(res.data)
        })
      })
    },
    // 人员、部门树
    getDeptUserTreeAll() {
      const _this = this
      getDeptUserTreeAll().then(res => {
        // 递归处理this.deptUserTreeAll，添加禁用状态和uuid
        const data = this._getDeptUserTreeAll(res.data[0].children)
        this.$nextTick(() => {
          this.$set(this.deptUserTreeAll, 'data', data)
          this.$set(this.approver, 'data', data)
        })
      })
    },
    removeItem(index, field) {
      if (this.formData[field].length === 1) return this.$toast('请至少保留一项')
      this.$dialog.confirm({
        message: '确定删除该项吗？',
      }).then(() => {
        this.formData[field].splice(index, 1)
      })
    },
    // 获取人员所属项目列表
    selectMyProjectList(user, more) {
      console.log('user', user)
      this.btnLoading = true
      return new Promise(resolve => {
        selectMyProjectList({projectMember: user.userId || user.Id, more}).then(res => {
          this.btnLoading = false
          this.ssxm.data = res.rows
          this.ssxm.filteredData = res.rows
          resolve(res.rows)
        })
      })
    },
  }
}
</script>
